import { useContext, useEffect, useState } from "react";
import "./discrepancyItem.scss";
import Input from "../../../../../components/Inputs/Input";
import { HTTP_RESPONSE_CODES } from "../../../../../globals/globals";
import { dropdownConfig } from "../../../../../services/dropdownsConfigService";
import Dropdowns from "../../../../../components/Dropdowns/Dropdowns";
import { DialogContext } from "../../../../../contexts/DialogContext";
import { DiscrepancyItemChatModal } from "../DiscrepancyItemChatModal/DiscrepancyItemChatModal";
import MultioptionButton from "../../../../../components/Buttons/MultioptionButton";
import { TextAreaComponent } from "../../../../../components/TextArea/TextAreaComponent";
import BasicDatePicker from "../../../../../components/Datepicker/Datepicker";
import {
  connectSocket,
  subscribeSocket,
} from "../../../../../Sockets/socketsConnection";

export const DiscrepancyItem = ({ data }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [form, setForm] = useState({
    id: null,
    status: null,
    orderType: null,
    line: null,
    location: null,
    supplyChain: null,
    createdBy: null,
    companyId: null,
    awbNumber: null,
    partNumber: null,
    categoryName: null,
    subCategoryName: null,
    serialNumber: null,
    vendorLot: null,
    uom: null,
    quantity: null,
    discrepancyDescription: null,
    discrepancyQuantity: null,
    discrepancyUomId: null,
    discrepancyShelfLife: null,
    discrenpancyPartNumber: "",
    discrepancyPartId: null,
    discrepancyCategotyId: null,
    discrepancyType: "",
  });
  const [AWBDrop, setAWBDrop] = useState(null);
  const [pnDrop, setPNDrop] = useState(null);
  const [discrepancyDrop, setDiscrepancyDrop] = useState(null);
  const [uomDrop, setUomDrop] = useState(null);

  const { openDialog, closeDialog } = useContext(DialogContext);
  const [edition, setEdition] = useState(false);


  // functions

  const openChatDialog = (title, channel) => {
    openDialog({
      component: DiscrepancyItemChatModal,
      props: {
        onClose: closeDialog,
        discrepancyId: form.id,
        titleChat: title,
        channel: channel,
       
      },
    });
  };

  const getDropdownConfigAWB = async () => {
    let id = 132;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setAWBDrop(request.data.load);
    }
  };

  const getDropdownConfigPN = async () => {
    let id = 29;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setPNDrop(request.data.load);
    }
  };

  const getDropdownConfigDiscrepancy = async () => {
    let id = 141;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setDiscrepancyDrop(request.data.load);
    }
  };

  const getDropdownConfigUOM = async () => {
    let id = 135;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setUomDrop(request.data.load);
    }
  };

  const getAllDropdowns = async () => {
    const results = await Promise.all([
      getDropdownConfigAWB(),
      getDropdownConfigPN(),
      getDropdownConfigDiscrepancy(),
      getDropdownConfigUOM(),
    ]);

    return results;
  };

  useEffect(() => {
    if (isOpen) {
      getAllDropdowns();
    }
  }, [isOpen]);

  const preloadForm = (data) => {
    setForm((prev) => {
      return { ...prev, ...data };
    });
  };

  useEffect(() => {
    preloadForm(data);
  }, []);

  const multiOptionsBtn = [
    { label: "Save", icon: "icon-save", id: "save" },
    { label: "Save And Finish", icon: "icon-save", id: "save-and-finish" },

    { label: "Cancel", icon: "icon-cross", id: "cancel", type: "danger" },
  ];

  const buttonsCallback = {
    save: () => {},
    "save-continue": () => {},
    cancel: () => {
      setEdition(false);
    },
  };

  // connection to WS
useEffect(() => {
  if (isOpen) {
    connectSocket()
  }
}, [form.id, isOpen]);


  return (
    <div className="discrepancy-item">
      <div
        className={`discrepancy-item-header item-sticky-header ${
          isOpen ? "item-open-header" : "item-closed-header"
        }`}
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        <p className="ellipsis">{form.id || "--"}</p>
        <p className="ellipsis">{form.orderType || "--"}</p>
        <p className="ellipsis">{form?.orderNumber || "--"}</p>
        <p className="ellipsis">{form.line || "--"}</p>
        <p className="ellipsis">{form.location || "--"}</p>
        <p className="ellipsis">{form.supplyChain || "--"}</p>
        <p className="ellipsis">{form.createdBy || "--"}</p>
        <button
          className={`ellipsis item-status-tag item-status-tag-${
            form.status == "Pending Review"
              ? "orange"
              : form.status == "Reviewed"
              ? "purple"
              : form.status == "Confirmed"
              ? "green"
              : form.status == "Resolution Provided"
              ? "blue"
              : form.status == "Sent to Vendor"
              ? "orange"
              : "red"
          }`}
        >
          {form.status || "--"}
        </button>
      </div>
      <div className={`discrepancy-item-content ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <section className="Discrepancy-item-form">
            <div className="discrepancy-item-edit-cont">
              <h3>Discrepancy Information</h3>
              {!edition ? (
                <button onClick={() => setEdition(true)}>
                  <i className="icon-edit"></i> Edit
                </button>
              ) : (
                <MultioptionButton
                  buttonCallbacks={buttonsCallback}
                  buttons={multiOptionsBtn}
                ></MultioptionButton>
              )}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "var(--gap)",
                width: "100%",
                height: "90%",
              }}
            >
              <div className="discrepancy-item-general-info-cont">
                <div
                  style={{
                    height: "2rem",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <h3>General Information</h3>
                </div>
                <section>
                  <div>
                    <Input
                      disabled={true}
                      label={"Status"}
                      value={form.status ?? "--"}
                    />
                    <Input
                      disabled={true}
                      label={"AWB"}
                      value={form.awbNumber ?? "--"}
                    />
                    {/* <div
                    style={{
                      width: "50%",
                    }}
                  >
                    {AWBDrop && (
                      <Dropdowns
                        disabled={true}
                        data={AWBDrop}
                        parameters={awbParams}
                      ></Dropdowns>
                    )}
                  </div> */}
                  </div>
                  <Input
                    disabled={true}
                    label={"PN"}
                    value={form.partNumber ?? "--"}
                  />
                  {/* <div
                // style={{
                //     width: "50%",
                //   }}
                >
                  {pnDrop && (
                    <Dropdowns
                      disabled={true}
                      data={pnDrop}
                      // parameters={awbParams}
                    ></Dropdowns>
                  )}
                </div> */}
                  <div>
                    <Input
                      disabled={true}
                      label={"PN Category"}
                      value={form.categoryName ?? "--"}
                    />
                    <Input
                      disabled={true}
                      label={"PN Sub-category"}
                      value={form.subCategoryName ?? "--"}
                    />
                  </div>
                  <div>
                    <Input
                      disabled={true}
                      label={"SN"}
                      value={form.serialNumber ?? "--"}
                    />
                    <Input
                      disabled={true}
                      label={"Vendor Lot"}
                      value={form.vendorLot ?? "--"}
                    />
                  </div>
                  <div>
                    <Input
                      disabled={true}
                      label={"Vendor Name"}
                      value={form?.vendorName ?? "--"}
                    />
                  </div>
                  <div>
                    <Input disabled={true} label={"UOM"} value={form.uom} />
                    <Input
                      disabled={true}
                      label={"QTY"}
                      value={form.quantity}
                      isNumeric={true}
                    />
                  </div>
                </section>
              </div>
              <div className="discrepancy-item-disc-info">
                <div
                  style={{
                    height: "2rem",
                  }}
                >
                  <h3 className="discrepancy-info-title">
                    Discrepancy Information
                  </h3>
                  <button
                    // onClick={() => setSentToVendor(true)}
                    className="discrepancy-item-sent-btn"
                    disabled={!edition}
                    style={{
                      // background : !edition ? "var(--disabled-input-bg)" : "",
                      // color : !edition ? "var(--grey-250)" : ""
                      opacity: !edition ? ".4" : "1",
                      pointerEvents: !edition ? "none" : "",
                    }}
                  >
                    Send To Vendor
                  </button>
                </div>
                <div
                  style={{
                    height: "20%",
                    flexDirection: "column",
                  }}
                >
                  {discrepancyDrop ? (
                    <div
                      style={{
                        width: "100%",
                      }}
                    >
                      <Dropdowns
                        disabled={true}
                        optionLabel={"name"}
                        data={discrepancyDrop}
                        preSelectValue={form.discrepancyCategotyId}
                        preventSelectionWithPreselect={false}
                        onOptionSelect={(e) => {
                          setForm((prev) => {
                            return {
                              ...prev,
                              discrepancyType: e.type,
                            };
                          });
                        }}
                      ></Dropdowns>
                    </div>
                  ) : (
                    ""
                  )}
                  {/* <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-around",
                    }}
                  >
                    <p>Requested QTY</p>
                    <Input
                      disabled={true}
                      style={{
                        width: "15%",
                        minWidth: "3rem",
                      }}
                      value={form.quantity}
                      isNumeric={true}
                    ></Input>
                    <p>Lt</p>
                    <p>Received QTY</p>
                    <Input
                      disabled={!edition}
                      style={{
                        width: "15%",
                        minWidth: "3rem",
                      }}
                      value={form.discrepancyQuantity}
                      isNumeric={true}
                    ></Input>
                    <p>UOM</p>
                    <div
                      style={{
                        width: "20%",
                      }}
                    >
                      {
                        uomDrop&& (
                          <Dropdowns data={uomDrop} preSelectValue={form.discrepancyUomId}></Dropdowns>
                        )
                      }
                    </div>
                  </div> */}
                  {form.discrepancyType == "Incorrect QTY" ? (
                    <div className="new-discrepancy-incorrect-qty-cont-fields">
                      <p>Requested QTY</p>
                      <Input
                        style={{
                          width: "15%",
                        }}
                        disabled={true}
                        value={form.quantity}
                        isNumeric={true}
                      />
                      <p>Received QTY</p>
                      <Input
                        style={{
                          width: "15%",
                        }}
                        isNumeric={true}
                        value={form.discrepancyQuantity}
                        disabled={true}
                      ></Input>
                      <p>UOM</p>
                      <div
                        style={{
                          width: "18%",
                        }}
                      >
                        <Dropdowns
                          hideLabel={true}
                          data={uomDrop}
                          preSelectValue={form.discrepancyUomId}
                          disabled={true}
                        ></Dropdowns>
                      </div>
                    </div>
                  ) : form.discrepancyType == "PN Does Not Exist" ? (
                    <Input
                      label={"Part Number (PN)"}
                      value={form.discrenpancyPartNumber}
                      disabled={true}
                    ></Input>
                  ) : form.discrepancyType == "Expired Shelf Life" ? (
                    <BasicDatePicker
                      label={"Shelf Life"}
                      name={"shelfLife"}
                      value={form.discrepancyShelfLife}
                      disabled={true}
                    ></BasicDatePicker>
                  ) : form.discrepancyType == "Wrong PN" ? (
                    <Dropdowns
                      data={pnDrop}
                      preSelectValue={form.discrepancyPartId}
                      disabled={true}
                    ></Dropdowns>
                  ) : null}
                </div>

                <div
                  style={{
                    // height: sentToVendor ? "40%" : "60%",
                    flexGrow: "1",
                    marginTop: ".4rem",
                  }}
                >
                  <TextAreaComponent
                    disabled={true}
                    value={form.discrepancyDescription}
                    label={"Discrepancy Description"}
                  ></TextAreaComponent>
                </div>
              </div>
              <div className="discrepancy-item-chat-vendor-cont">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    height: "2rem",
                  }}
                >
                  <h3>Discrepancy Resolution</h3>
                  <button
                    className="discrepancy-item-vendor-chat-btn"
                    onClick={() => {
                      openChatDialog("Receiver Chat", "store");
                    }}
                    style={{
                      // background : !edition ? "var(--disabled-input-bg)" : "",
                      // color : !edition ? "var(--grey-250)" : ""
                      opacity: !edition ? ".4" : "1",
                      pointerEvents: !edition ? "none" : "",
                    }}
                  >
                    <i
                      className="icon-chat"
                      style={{
                        fontSize: "calc(var(--p-size) + .3rem)",
                      }}
                    ></i>
                    Receiver
                    <span>1</span>
                  </button>
                  <button
                    className="discrepancy-item-vendor-chat-btn"
                    onClick={() => {
                      openChatDialog("Vendor Chat", "vendor");
                    }}
                    style={{
                      // background : !edition ? "var(--disabled-input-bg)" : "",
                      // color : !edition ? "var(--grey-250)" : ""
                      opacity: !edition ? ".4" : "1",
                      pointerEvents: !edition ? "none" : "",
                    }}
                  >
                    <i
                      className="icon-chat"
                      style={{
                        fontSize: "calc(var(--p-size) + .3rem)",
                      }}
                    ></i>
                    Vendor
                    <span>1</span>
                  </button>
                </div>
                <section className="discrepancy-item-resolution-inp-cont">
                  <TextAreaComponent
                    label={"Description"}
                    disabled={!edition}
                    name={"resolution"}
                    onChange={(e) => {
                      console.log(e);
                    }}
                  ></TextAreaComponent>
                  <button
                    className="discrepancy-item-mark-resold-btn filled"
                    style={{
                      // background : !edition ? "var(--disabled-input-bg)" : "",
                      // color : !edition ? "var(--grey-250)" : ""
                      opacity: !edition ? ".4" : "1",
                      pointerEvents: !edition ? "none" : "",
                    }}
                  >
                    Mark As Resolved
                  </button>
                </section>
              </div>
            </div>
          </section>
        )}
      </div>
    </div>
  );
};
